import { CSSProperties } from "react";
import "./Loader.css";

type LoaderProps = {
  LoaderMain_containerClassNAme?: any;
  style?: CSSProperties;
};

const Loader = ({ LoaderMain_containerClassNAme, style }: LoaderProps) => {
  return (
    <div
      className={`LoaderMain_container ${LoaderMain_containerClassNAme} `}
      style={style}
    ></div>
  );
};

export default Loader;
